import React, { FC, useEffect, useState, useRef, useContext } from 'react'
import moment from 'moment'
import { isMobile } from 'react-device-detect'

import { WizzardVideo } from './style/UserWIzzardStyle'

import GenericBackgroundLayer from '../../GenericComponents/GenericBackgroundLayer'
import GenericBackButton from '../../GenericComponents/GenericBackButton'
import GenericMainCart from '../../GenericComponents/GenericMainCard'
import GenericTextSpan from '../../GenericComponents/GenericTextSpan'
import GenericButton from '../../GenericComponents/GenericButton'
import GenericLogo from '../../GenericComponents/GenericLogo'
import { usePromiseTracker, trackPromise } from 'react-promise-tracker'

import WizzardPagination from './views/WizzardPagination'
import WizzardPage0 from './views/WizzardPage0'
import WizzardPage1 from './views/WizzardPage1'
import WizzardPage2 from './views/WizzardPage2'
import WizzardPage3 from './views/WizzardPage3'
import WizzardPage4 from './views/WizzardPage4'
import WizzardPage5 from './views/WizzardPage5'
import WizzardPage6 from './views/WizzardPage6'
import WizzardPhotoMode from './views/WizzardPhotoMode'
import Loader from '../Loader/Loader'
import history from '../../history'

import { getSingleVideo } from '../../Api/videoApi'
import {
  addUserFeed,
  setUserTrainingDays,
  generatePhotoAwsUrl,
  patchUserData,
  getUserData,
  getMissingSteps,
} from '../../Api/backendApi'

import AppContext from '../../context/appContext'
import { arrayRemove } from '../../utils/ArrayHelpers'

interface UserWizzardPropsInterface {}

interface SingleVideoInterface {
  files: Array<string>
  duration: number
}

const UserWizzard: FC<UserWizzardPropsInterface> = () => {
  const singleVideoRef = useRef(null)
  const appContext = useContext(AppContext)
  const { promiseInProgress } = usePromiseTracker()

  const [user, setUser] = useState(Object)
  const [actualPage, setActualPage] = useState(0)
  const [userName, setUserName] = useState(String)
  const [showVideo, setShowVideo] = useState(false)
  const [singleVideo, setSingleVideo] = useState<SingleVideoInterface>()
  const [stopPlayingSingleVideo, setStopPlayingSingleVideo] = useState(false)
  const [dimensionsPart, setDimensionsPart] = useState(Object)
  const [bellyDimension, setBellyDimension] = useState(null)
  const [hipDimension, setHipDimension] = useState(null)
  const [thighDimension, setThighDimension] = useState(null)
  const [photoMode, setPhotoMode] = useState(false)
  const [frontPhoto, setFrontPhoto] = useState({
    displayPhoto: '',
    filePhoto: null,
  })
  const [backPhoto, setBackPhoto] = useState({
    displayPhoto: '',
    filePhoto: null,
  })
  const [sidePhoto, setSidePhoto] = useState({
    displayPhoto: '',
    filePhoto: null,
  })
  const [photoOrder, setPhotoOrder] = useState(0)
  const [chosenTrainingDays, setChosenTrainingDays] = useState(Array)
  const [trainingTime, setTrainingTime] = useState('')
  const [missingSteps, setMissingSteps] = useState([])

  const obtainVideo = async () => {
    let video = await getSingleVideo()

    setSingleVideo(video)
    return video
  }

  const obtainMissingSteps = async () => {
    const steps: any = await getMissingSteps()
    setMissingSteps(steps && steps.missing_steps)
  }

  useEffect(() => {
    obtainMissingSteps()
    obtainUser()
    obtainVideo()
  }, [])

  useEffect(() => {
    if (missingSteps.length) {
      handleMissingSteps()
    }
  }, [missingSteps])

  const obtainUser = async () => {
    if (appContext.appState.user) {
      setUser(appContext.appState.user)
    }

    const user = await getUserData()
    setUser(user)
    appContext.updateAppState('user', user)
  }

  // Manage playing welcome video
  useEffect(() => {
    if (!stopPlayingSingleVideo) {
      const interval = setInterval(() => {
        if (singleVideoRef.current && singleVideo) {
          const vid: any = document.getElementById('vid')
          if (vid.currentTime >= singleVideo.duration - 1) {
            setStopPlayingSingleVideo(true)
            setShowVideo(false)
            setActualPage(actualPage + 1)
          }
        }
      }, 1000)
      return () => clearInterval(interval)
    }
  }, [showVideo, stopPlayingSingleVideo])

  const handleChangeTrainingDay = (e: any) => {
    if (chosenTrainingDays.length >= 5) {
      if (!chosenTrainingDays.includes(e.target.name)) {
      } else {
        let newDays = arrayRemove(chosenTrainingDays, e.target.name)
        setChosenTrainingDays(newDays)
      }
    } else {
      if (!chosenTrainingDays.includes(parseInt(e.target.name))) {
        setChosenTrainingDays([...chosenTrainingDays, parseInt(e.target.name)])
      } else {
        let newDays = arrayRemove(chosenTrainingDays, e.target.name)
        setChosenTrainingDays(newDays)
      }
    }
  }

  // manage user flow based on missing steps endpoint and
  const handleMissingSteps = () => {
    let isRedirected: boolean = false

    if (missingSteps.includes('NAME_SCREEN')) {
      setActualPage(0)
      isRedirected = true
      return
    }

    if (!isRedirected && missingSteps.includes('FEED_SCREEN')) {
      setActualPage(1)
      isRedirected = true
      return
    }

    if (!isRedirected && missingSteps.includes('TRAINING_PLAN_SCREEN')) {
      setActualPage(5)
      isRedirected = true
      return
    }
  }

  // manage displaying content
  const handleChangeCardContent = () => {
    switch (actualPage) {
      case 0:
        if (!showVideo) {
          return (
            <WizzardPage0 getUserName={userName!} setUserName={setUserName} />
          )
        } else {
          return (
            <>
              <GenericTextSpan position="absolute" top={'-5%'}>
                {' '}
                Obejrzyj film do końca
              </GenericTextSpan>
              <WizzardVideo
                id="vid"
                ref={singleVideoRef}
                autoPlay
                playsinline={true}
                playsInline
                webkit-playsinline={true}
                webkit-playsInline
                src={singleVideo && singleVideo.files[0].link}
              ></WizzardVideo>
            </>
          )
        }
      case 1:
        return (
          <WizzardPage1
            getBellyDimension={bellyDimension!}
            setBellyDimension={setBellyDimension}
          />
        )
      case 2:
        return (
          <WizzardPage2
            getHipDimension={hipDimension!}
            setHipDimension={setHipDimension}
          />
        )
      case 3:
        return (
          <WizzardPage3
            getThighDimension={thighDimension!}
            setThighDimension={setThighDimension}
          />
        )
      case 4:
        if (!photoMode) {
          return <WizzardPage4 />
        } else {
          return <div></div>
        }
      case 5:
        return (
          <WizzardPage5
            handleChangeTrainingDay={handleChangeTrainingDay}
            chosenTrainingDays={chosenTrainingDays}
            singleComponent={false}
          />
        )
      case 6:
        return <WizzardPage6 setTrainingTime={setTrainingTime} />
      default:
        return
    }
  }

  // manage displaying text
  const handleChangeCardText = () => {
    let text: string = ''

    switch (actualPage) {
      case 0:
        text = ' Wpisz swoje imię'
        break
      case 1:
        text = 'Zmierz obwód brzucha na wysokości pępka'
        break
      case 2:
        text = 'Zmierz obwód bioder w najszerszym ich miejscu'
        break
      case 3:
        text = 'Zmierz obwód uda'
        break
      case 4:
        if (photoMode) {
          if (photoOrder == 0) {
            text = 'Wgraj zdjęcie z przodu'
          } else if (photoOrder == 1) {
            text = 'Wgraj zdjęcie z boku'
          } else {
            text = 'Wgraj zdjęcie z tyłu'
          }
        } else {
          text = 'Przygotuj się do zrobienia zdjęć'
        }

        break
      case 5:
        text = 'Wybierz 5 dni treningowych'
        break
      case 6:
        text = 'Wpisz godzinę treningu'
        break
      default:
        return
    }

    return text
  }

  const handleImageUpload = (e: any, photoOrder: number) => {
    if (e.target.files[0]) {
      switch (photoOrder) {
        case 0:
          setFrontPhoto({
            displayPhoto: URL.createObjectURL(e.target.files[0]),
            filePhoto: e.target.files[0],
          })
          break
        case 1:
          setSidePhoto({
            displayPhoto: URL.createObjectURL(e.target.files[0]),
            filePhoto: e.target.files[0],
          })
          break
        case 2:
          setBackPhoto({
            displayPhoto: URL.createObjectURL(e.target.files[0]),
            filePhoto: e.target.files[0],
          })
          break
      }
    }
  }

  const shouldDisplayNextButtonOnPhotoMode = () => {
    let displayNextButton: any = false
    switch (photoOrder) {
      case 0:
        frontPhoto.filePhoto === null
          ? (displayNextButton = false)
          : (displayNextButton = true)
        break
      case 1:
        sidePhoto.filePhoto === null
          ? (displayNextButton = false)
          : (displayNextButton = true)
        break
      case 2:
        backPhoto.filePhoto === null
          ? (displayNextButton = false)
          : (displayNextButton = true)
        break
      default:
        return
    }
    return displayNextButton
  }

  const shouldRenderNextButton = () => {
    let shouldRenderButton: boolean = false

    switch (actualPage) {
      case 0:
        showVideo ? (shouldRenderButton = false) : (shouldRenderButton = true)
        break
      case 1:
        //setShowVideo(true)
        shouldRenderButton = true
        break
      case 2:
        shouldRenderButton = true
        break
      case 3:
        shouldRenderButton = true
        break
      case 4:
        photoMode
          ? (shouldRenderButton = shouldDisplayNextButtonOnPhotoMode())
          : (shouldRenderButton = true)
        break
      case 5:
        shouldRenderButton = true
        break
      case 6:
        shouldRenderButton = true
        break
      default:
        return
    }

    return shouldRenderButton
  }

  const checkIfNameIsCorrect = () => {
    return (
      userName == null ||
      userName == '' ||
      (userName && userName.length < 3) ||
      userName.length > 40
    )
  }

  const checkIfBellyIsCorrect = () => {
    return (
      bellyDimension == null ||
      bellyDimension == '' ||
      (bellyDimension && bellyDimension! < 20) ||
      bellyDimension! > 300
    )
  }

  const checkIfHipIsCorrect = () => {
    return (
      hipDimension == null ||
      hipDimension == '' ||
      (hipDimension && hipDimension! < 20) ||
      hipDimension! > 300
    )
  }

  const checkIfThighIsCorrect = () => {
    return (
      thighDimension == null ||
      thighDimension == '' ||
      (thighDimension && thighDimension! < 20) ||
      thighDimension! > 300
    )
  }

  const handleNextButtonAction = async () => {
    switch (actualPage) {
      case 0:
        // only one missing step - the first one
        if (missingSteps.length == 1 && missingSteps.includes('NAME_SCREEN')) {
          let userDataResponse = await trackPromise(
            patchUserData(userName, false, true, user.id)
          )
          if (userDataResponse) history.replace('/redirect')
        } else if (missingSteps.length > 1) {
          if (missingSteps.includes('FEED_SCREEN') && !showVideo) {
            setShowVideo(true)
          } else if (missingSteps.includes('FEED_SCREEN') && showVideo) {
            setActualPage(actualPage + 1)
          } else if (
            !missingSteps.includes('FEED_SCREEN') &&
            missingSteps.includes('TRAINING_PLAN_SCREEN')
          ) {
            setActualPage(5)
          }
        }

        break
      case 1:
        if (checkIfBellyIsCorrect()) {
          return
        } else {
          setActualPage(actualPage + 1)
        }
        break
      case 2:
        if (checkIfHipIsCorrect()) {
          return
        } else {
          setActualPage(actualPage + 1)
        }
        break
      case 3:
        setPhotoMode(false)
        if (checkIfThighIsCorrect()) {
          return
        } else {
          setActualPage(actualPage + 1)
        }
        break
      case 4:
        if (!photoMode) {
          setPhotoMode(true)
        } else if (photoMode) {
          if (frontPhoto.filePhoto && photoOrder == 0) {
            setPhotoOrder(1)
          } else if (
            frontPhoto.filePhoto &&
            sidePhoto.filePhoto &&
            photoOrder == 1
          ) {
            setPhotoOrder(2)
          } else if (
            frontPhoto.filePhoto &&
            sidePhoto.filePhoto &&
            backPhoto.filePhoto &&
            photoOrder == 2
          ) {
            if (missingSteps.includes('TRAINING_PLAN_SCREEN')) {
              setPhotoMode(false)
              setActualPage(actualPage + 1)
            } else {
              if (
                frontPhoto.filePhoto &&
                sidePhoto.filePhoto &&
                backPhoto.filePhoto
              ) {
                setTimeout(async () => {
                  let frontPhotoResponse: any
                  frontPhotoResponse = await trackPromise(
                    generatePhotoAwsUrl('F', frontPhoto.filePhoto)
                  )

                  let sidePhotoResponse: any
                  sidePhotoResponse = await trackPromise(
                    generatePhotoAwsUrl('S', sidePhoto.filePhoto)
                  )

                  let backPhotoResponse: any
                  backPhotoResponse = await trackPromise(
                    generatePhotoAwsUrl('B', backPhoto.filePhoto)
                  )
                }, 1000)
              }
              const date = new Date()
              const correctDate = moment(date).format('YYYY-MM-DD')
              const userFeedResponse: any = await trackPromise(
                addUserFeed(
                  bellyDimension,
                  hipDimension,
                  thighDimension,
                  correctDate
                )
              )

              if (userFeedResponse) history.replace('/redirect')
            }
          }
        }

        break
      case 5:
        setPhotoMode(false)
        if (chosenTrainingDays.length < 5) {
          return
        } else {
          setActualPage(actualPage + 1)
        }
        break
      case 6:
        if (trainingTime !== null) {
          if (
            missingSteps.includes('TRAINING_PLAN_SCREEN') &&
            missingSteps.length == 1
          ) {
            let userTrainingResponse: any
            const hour = trainingTime && trainingTime.split(':')
            userTrainingResponse = await trackPromise(
              setUserTrainingDays(chosenTrainingDays, hour[0], hour[1])
            )
            if (userTrainingResponse) history.replace('/redirect')
          } else {
            storeUserData()
          }
        }
        break
      default:
        return
    }
  }

  const handleNextButtonText = () => {
    let text = ''
    switch (actualPage) {
      case 0:
        text = 'Przejdź dalej'
        break
      case 1:
        text = 'Przejdź dalej'
        break
      case 2:
        text = 'Przejdź dalej'
        break
      case 3:
        text = 'Przejdź dalej'
        break
      case 4:
        if (!photoMode) {
          text = 'Przejdź dalej'
        } else if (photoMode) {
          if (frontPhoto.filePhoto) {
            text = 'Dodaj zdjęcie'
          }
          if (sidePhoto.filePhoto) {
            text = 'Dodaj zdjęcie'
          }
          if (backPhoto.filePhoto) {
            text = 'Przejdź dalej'
          }
        }

        break
      case 5:
        text = 'Przejdź dalej'
        break
      case 6:
        text = 'Przejdź dalej'
        break
      default:
        return
    }
    return text
  }

  const storeUserData = async () => {
    const date = new Date()
    const correctDate = moment(date).format('YYYY-MM-DD')
    const hour = trainingTime && trainingTime.split(':')
    let frontPhotoResponse: any
    let userFeedResponse: any
    let sidePhotoResponse: any
    let backPhotoResponse: any
    let userTrainingResponse: any
    let userDataResponse: any

    userFeedResponse = await trackPromise(
      addUserFeed(bellyDimension, hipDimension, thighDimension, correctDate)
    )

    if (backPhoto.filePhoto && sidePhoto.filePhoto && frontPhoto.filePhoto) {
      userDataResponse = await trackPromise(
        patchUserData(userName, false, true, user.id)
      )

      if (userDataResponse) {
        frontPhotoResponse = await trackPromise(
          generatePhotoAwsUrl('F', frontPhoto.filePhoto)
        )

        sidePhotoResponse = await trackPromise(
          generatePhotoAwsUrl('S', sidePhoto.filePhoto)
        )

        backPhotoResponse = await trackPromise(
          generatePhotoAwsUrl('B', backPhoto.filePhoto)
        )

        if (backPhotoResponse && sidePhotoResponse && frontPhotoResponse) {
          userTrainingResponse = await trackPromise(
            setUserTrainingDays(chosenTrainingDays, hour[0], hour[1])
          )

          if (userTrainingResponse) {
            userDataResponse = await trackPromise(
              patchUserData(userName, false, true, user.id)
            )
          }

          if (userTrainingResponse.status && userDataResponse.status) {
            history.replace('/redirect')
          } else {
            setActualPage(0)
          }
        }
      }
    } else {
      userTrainingResponse = await trackPromise(
        setUserTrainingDays(chosenTrainingDays, hour[0], hour[1])
      )

      if (userTrainingResponse) {
        userDataResponse = await trackPromise(
          patchUserData(userName, false, true, user.id)
        )
      }

      if (userTrainingResponse.status && userDataResponse.status) {
        history.replace('/redirect')
      } else {
        setActualPage(0)
      }
    }
  }

  return (
    <GenericBackgroundLayer
      fDir="column"
      justify="flex-start"
      className="standard"
    >
      <GenericBackButton
        style={'default'}
        handleClick={() => {
          if (actualPage == 5) {
            setPhotoMode(true)
          }

          if (actualPage > 0) {
            if (actualPage == 4 && photoMode) {
              if (photoMode && photoOrder > 0) {
                setPhotoOrder(photoOrder - 1)
              } else {
                setPhotoMode(false)
              }
            } else {
              setActualPage(actualPage - 1)
            }
          }
        }}
      />
      {!photoMode ? (
        <>
          <WizzardPagination page={actualPage} />
          <GenericMainCart
            // minHeight={`${
            //   actualPage == 4
            //     ? isMobile
            //       ? '55vh'
            //       : '62vh'
            //     : isMobile
            //     ? '50vh'
            //     : '55vh'
            // }`}
            flexDir={`column`}
            justify={'flex-start'}
            width={`${
              actualPage == 0 && showVideo
                ? isMobile
                  ? '90vw'
                  : '44vw'
                : isMobile
                ? '90vw'
                : '44vw'
            }`}
            className={`standard ${
              actualPage == 0 && showVideo && 'no-padding'
            } ${photoMode && isMobile && 'photomode-mobile-card'} ${
              actualPage == 5 && isMobile && 'select-training-day'
            }`}
          >
            {actualPage == 0 && showVideo ? null : (
              <GenericTextSpan
                display={'block'}
                margin={'10% 0 0 0'}
                fSize={isMobile ? '1.9rem' : '1.5rem'}
              >
                {handleChangeCardText()}
              </GenericTextSpan>
            )}
            {handleChangeCardContent()}
            {shouldRenderNextButton() && (
              <GenericButton
                className={`with-arrow standard ${
                  ((actualPage == 0 && checkIfNameIsCorrect()) ||
                    (actualPage == 1 && checkIfBellyIsCorrect()) ||
                    (actualPage == 2 && checkIfHipIsCorrect()) ||
                    (actualPage == 3 && checkIfThighIsCorrect()) ||
                    (actualPage == 5 && chosenTrainingDays.length < 5) ||
                    (actualPage == 6 && trainingTime == null)) &&
                  'inactive'
                }`}
                justify={'center'}
                position={'relative'}
                // bottom={'5vh'}
                margin={'10% 0 0 0'}
                width={isMobile ? '90%' : '40%'}
                padding={'10px 20px'}
                onClick={() => handleNextButtonAction()}
              >
                {handleNextButtonText()}
              </GenericButton>
            )}
            {actualPage == 4 && !photoMode && (
              <GenericTextSpan
                onClick={() => setActualPage(actualPage + 1)}
                className={'link'}
                fSize={isMobile ? '1rem' : '0.65rem'}
                position={'relative'}
                margin={'3% 0 0 2%'}
              >
                Pomiń ten krok
              </GenericTextSpan>
            )}
          </GenericMainCart>
        </>
      ) : (
        <WizzardPhotoMode
          photoOrder={photoOrder}
          frontPhoto={frontPhoto}
          sidePhoto={sidePhoto}
          backPhoto={backPhoto}
          handleImageUpload={handleImageUpload}
          handleNextButtonAction={handleNextButtonAction}
          handleNextButtonText={handleNextButtonText}
          isEntryMode={false}
        />
      )}
      <GenericLogo
        className="wizzardo-logo"
        theme={appContext.appState.theme == 'light' ? 'light' : null}
        position={'absolute'}
        bottom={window.innerWidth < 400 ? '-1vh' : '5vh'}
        width={'15%'}
        display={
          (isMobile && (actualPage == 4 || actualPage == 5)) || actualPage == 4
            ? 'none'
            : 'flex'
        }
      />

      {promiseInProgress && <Loader />}
    </GenericBackgroundLayer>
  )
}

export default UserWizzard
